export default __webpack_public_path__ + "static/media/5_Products_banner.500d5c5c.png";